export default context => {
    const container = $('.share-communities-widget', context)
    if (container.length) {
        const update = function (elements, value) {
            if (value) {
                elements.each(function () {
                    $(this).prop('checked', true)
                    $(this).parent().addClass('active')
                })
            } else {
                elements.each(function () {
                    $(this).prop('checked', false)
                    $(this).parent().removeClass('active')
                })
            }
            refreshSelectAll()
        }
        const refreshSelectAll = function() {
            container.find('input[name="select_all"]').each(function() {
                const elements = $(this).closest('.tag-group-category').find('.tags-list input[type="checkbox"]');
                $(this).prop('checked', elements.length > 0 && elements.filter(':not(:checked)').length === 0)
            })
        }
        container.find('.tag-group-category input[name="select_all"]').on('click', function () {
            const elements = $(this).closest('.tag-group-category').find('.tags-list input[type="checkbox"]')
            update(elements, $(this).prop('checked'))
            elements.trigger('change')
        })

        container.find('.tags-list .btn input[type="checkbox"]').on('change', function () {
            update(container.find('.tags-list .btn input[type="checkbox"][value="' + $(this).val() + '"]'), $(this).prop('checked'))
        })
        container.find('.show-community-selector').on('click', () => {
            container.find('.tag-group-list.hide').removeClass('hide')
            return false
        })
        refreshSelectAll()
    }
}
